import baseCN from "./cn/cn_base.js";
import commonCN from "./cn/cn_common.js";
import fogCN from "./cn/cn_fog.js";
import homeCN from "./cn/cn_home.js";
import memberCN from "./cn/cn_member.js";
import publicCN from "./cn/cn_public.js";
import searchCN from "./cn/cn_search.js";
import settingCN from "./cn/cn_setting.js";
import user_centralCN from "./cn/cn_user_central.js";
import cn_msg_codeCN from "./cn/cn_msg_code.js";
import build_message from "./build_message.js";
import genCN from "./cn/cn_gen";
const messagesCn = build_message([
  genCN,
  baseCN,
  commonCN,
  fogCN,
  homeCN,
  memberCN,
  publicCN,
  searchCN,
  settingCN,
  user_centralCN,
  cn_msg_codeCN
]);
export default messagesCn;



// WEBPACK FOOTER //
// ./src/lan/cn.js